<template>
  <div class="product-search-box show-flex-box-r">
    <div class="show-flex-box-r">
      <span class="search-input show-flex-box-r">
        <input type="text" :placeholder="placeholderParams.content" v-model="searchParam">
      </span>
      <strong class="show-flex-box-r" @click="inputSearchInfo">
        <span></span>
        <h1>搜索</h1>
      </strong>
    </div>
  </div>
</template>

<script>
/*
 * 需要参数：
 *  :placeholderParams {
 *     'content',      -->输入框默认显示内容
 * }
 *
 * 获取搜索内容方法：@input-search-info
 */

export default {
  name: "product_search_cpn",
  data() {
    return {
      searchParam: "",
      loading: false,
      routerInfo: ""
    };
  },
  props: {
    placeholderParams: [String, Object]
  },
  created() {
    this.reqRouterPath();
  },
  mounted() {
    this.listenKeyEvent();
  },
  methods: {
    reqRouterPath: function() {
      this.routerInfo = this.$route.name;
    },
    listenKeyEvent() {
      let vSelf = this;
      $(document).keyup(function(event) {
        if (event.keyCode == 13) {
          if (!vSelf.loading && !vSelf.$route.query.id && (vSelf.routerInfo == "marsbox_store" || vSelf.routerInfo == "course_store")) {
            vSelf.inputSearchInfo();
          }
        }
      });
    },
    inputSearchInfo: function() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      if (this.searchParam != "") {
        this.loading = false;
        this.$emit("input-search-info", this.searchParam);
      } else {
        this.loading = false;
        this.$elementMsg.error({
          message: "请输入搜索内容",
          showClose: true,
          customClass: "pop-class-error",
          duration: 3000
        });
      }
    }
  },
  watch: {
    searchParam: function() {
      if (this.searchParam == "") {
        this.$emit("input-search-info", false);
      }
    },
    $route: function(from) {
      this.reqRouterPath();
    },
  }
};
</script>

<style lang="less" scoped>
.product-search-box {
  width: 100%;
  height: 100%;
  & > div {
    width: 100%;
    height: 100%;
    justify-content: space-between;
    align-items: center;
    & > .search-input {
      width: 78.5%;
      height: 100%;
      background: #fff;
      border: 1px solid #e5e5e5;
      border-radius: 30px 0 0 30px;
      & > input {
        flex-grow: 1;
        padding-left: 30px;
        height: 100%;
        border: none;
        background: none;
        line-height: auto;
        font-size: 18px;
        color: #808080;
      }
    }
    & > strong {
      width: 21.5%;
      height: 100%;
      justify-content: center;
      align-items: center;
      background: #ff7800;
      border: 1px solid #ff7800;
      border-left: none;
      border-radius: 0 30px 30px 0;
      cursor: pointer;
      & > span {
        display: block;
        width: 20px;
        height: 20px;
        background: url("../../../assets/mars_store/mars_search_icon.png")
          no-repeat center center;
        background-size: 20px 20px;
      }
      & > h1 {
        display: block;
        line-height: auto;
        font-size: 18px;
        font-weight: 500;
        color: #fff;
        margin-left: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mars_box_store/common/product_search_cpn.vue